import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
// import { Dialog } from "./components/index.js";
import { Modal } from "react-responsive-modal";
import "./ARIConfirmMileageExceededModal.scss";
import { useEffect } from "react";
import holmanLogo from "assets/logo/holmanLogo.png";

function ARIConfirmMileageExceededModal(props) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(props.isOpen);
  const [isDisableDeflectionBypass, setIsDisableDeflectionBypass] = useState(props.isDisableDeflectionBypass);

  useEffect(() => {
    setIsOpen(!!props.isOpen);
  }, [props.isOpen]);

  useEffect(() => {
    setIsDisableDeflectionBypass(!!props.isDisableDeflectionBypass);
  }, [props.isDisableDeflectionBypass]);

  const onNoClicked = () => {
    setIsOpen(false);
    if (typeof props.onNo === "function") {
      props.onNo();
    }
  };

  const onYesClicked = () => {
    setIsOpen(false);
    onUserCancel();
    if (typeof props.onYes === "function") {
      props.onYes();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal
        classNames={{ modal: "TVLAccidentModal" }}
        open={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        showCloseIcon={false}
      >
        {/* <h2 style={{marginTop: 30}}>{t("description.TVLAccidentQuestionHeader")}</h2> */}
        <img className="img" src={holmanLogo} alt="Holman logo" />

        <div class="message">{t("ARI.MileageExceeded.Message1")}</div>
        {!isDisableDeflectionBypass && <div class="message">{t("ARI.MileageExceeded.Message2")}</div>}

        <div className="footerContainer">
          <div
            type="hidden"
            onClick={onYesClicked}
            className="footer"
            style={{
              color: isDisableDeflectionBypass ? "white" : "black",
              backgroundColor: isDisableDeflectionBypass ? "black" : "#e0e0e0",
            }}
          >
            <span>{t("description.ConfirmServicesCancel")}</span>
          </div>
          {!isDisableDeflectionBypass && (
            <div type="hidden" onClick={onNoClicked} className="footer">
              <div class="text-center">{t("description.ConfirmServicesContinue")}</div>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
export default ARIConfirmMileageExceededModal;
